<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    :style="{ zIndex: options.zIndex }"
    :persistent="persistent"
    class="x-dialog"
    content-class="x-dialog__content"
  >
    <v-card>
      <slot name="header">
        <v-card-title style="padding: 15px 20px 15px 15px">
          <v-spacer/>
          <v-btn
            icon
            height="19"
            width="19"
            color="primary"
            @click="cancel"
          >
            <v-icon size="19">{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
      </slot>
      <slot name="content">
        <v-card-text v-show="!!message" class="px-5 pb-10 text-pre-wrap text-center x-font__primary error--text">
          {{ message }}
        </v-card-text>
      </slot>
      <slot name="actions" :options="options" :agree="agree" :cancel="cancel">
        <v-card-actions class="pt-0 pb-8 px-8" v-if="showActions">
          <v-spacer/>
          <x-btn
            v-if="options.cancelVisible"
            variant="cancel"
            @click.native="cancel"
          >
            {{ options.cancelText }}
          </x-btn>
          <x-btn
            variant="primary"
            @click.native="agree"
          >
            {{ options.agreeText }}
          </x-btn>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
import XBtn from "../btn/XBtn"
import {mdiClose} from "@mdi/js"

export default {
  name: 'x-confirm-dialog',
  components: {
    XBtn
  },
  props: {
    persistent: {
      required: false,
      default: true
    },
    showActions: {
      required: false,
      default: true,
    }
  },
  data() {
    return {
      icons: {
        mdiClose
      },
      dialog: false,
      resolve: null,
      reject: null,
      message: null,

      options: {
        color: null,
        width: null,
        zIndex: null,
        agreeText: null,
        cancelText: null,
        cancelVisible: null,
        onAgree: null,
        onCancel: null,
      },

      defaultOptions: {
        color: 'primary',
        width: 260,
        zIndex: 1000,
        agreeText: 'Да',
        cancelText: 'Нет',
        cancelVisible: true,
        onAgree: () => {
        },
        onCancel: () => {
        },
      }
    }
  },
  methods: {
    open(message, options) {
      this.dialog = true
      this.message = message
      this.options = {
        color: (!!options && options.color) || this.defaultOptions.color,
        width: (!!options && options.width) || this.defaultOptions.width,
        zIndex: (!!options && options.zIndex) || this.defaultOptions.zIndex,
        agreeText: (!!options && options.agreeText) || this.defaultOptions.agreeText,
        cancelText: (!!options && options.cancelText) || this.defaultOptions.cancelText,
        cancelVisible: !!options ? options.cancelVisible : this.defaultOptions.cancelVisible,
        onAgree: (!!options && options.onAgree) || this.defaultOptions.onAgree,
        onCancel: (!!options && options.onCancel) || this.defaultOptions.onCancel,
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    agree() {
      this.resolve(true)
      this.dialog = false
      this.options.onAgree()
    },

    cancel() {
      this.resolve(false)
      this.dialog = false
      this.options.onCancel()
    }
  }
}
</script>